import { defineMessages } from 'react-intl';

export const consolidatedSessionsListMessages = defineMessages({
  filterSessions: {
    defaultMessage: 'Filter sessions',
    id: 'hI1dcU/jcq',
    description:
      'Aria label and title for the consolidated sessions list settings popover',
  },
  goBack: {
    defaultMessage: 'Go back',
    id: 'dLjAeXnEmn',
    description: 'Aria label for back button in sessions filter detail panel',
  },
  viewSessionsAs: {
    defaultMessage: 'View sessions as',
    id: 'ZCZ6PvraI8',
    description: 'Label for selecting whose sessions to review in the sessions filter',
  },
  me: {
    defaultMessage: 'Me',
    id: 'MzT8I7hAxq',
    description: 'Option for viewing the current user’s own sessions',
  },
  filter: {
    defaultMessage: 'Filter',
    id: 'CVc2fgYaxh',
    description: 'Section heading for filter options in sessions settings',
  },
  display: {
    defaultMessage: 'Display',
    id: 'zk1aaN9MCn',
    description: 'Section heading for sort/display options in sessions settings',
  },
  orderBy: {
    defaultMessage: 'Order by',
    id: 'wLMLVQQ38h',
    description: 'Label for the session list sort field selector',
  },
  dateCreated: {
    defaultMessage: 'Date created',
    id: 'PhHl4XZ52x',
    description: 'Sort option: order sessions by creation date',
  },
  dateUpdated: {
    defaultMessage: 'Date updated',
    id: '0l6PiJlGJe',
    description: 'Sort option: order sessions by last update date',
  },
  name: {
    defaultMessage: 'Name',
    id: 'BUWKE8k6gf',
    description: 'Sort option: order sessions by name',
  },
  status: {
    defaultMessage: 'Status',
    id: 'UMsdskC8V8',
    description: 'Sort option: order sessions by status',
  },
  ascending: {
    defaultMessage: 'Ascending',
    id: 'jh6ammd76C',
    description: 'Aria label to switch session list sort to ascending',
  },
  descending: {
    defaultMessage: 'Descending',
    id: 'qDBBxygT3J',
    description: 'Aria label to switch session list sort to descending',
  },
  tidySessions: {
    defaultMessage: 'Tidy sessions',
    id: 'BcSEKUghEw',
    description: 'Button to delete empty sessions from the list',
  },
  clearFilters: {
    defaultMessage: 'Clear filters',
    id: '7GBryw/p63',
    description: 'Button to reset all session list filters',
  },
  date: {
    defaultMessage: 'Date',
    id: 'FQsPQLtBy2',
    description: 'Sessions filter — date filter row and panel title',
  },
  statusFilter: {
    defaultMessage: 'Status',
    id: 'uepe7lmBr1',
    description: 'Sessions filter — status filter row and panel title',
  },
  patientProfile: {
    defaultMessage: 'Patient profile',
    id: 'qCbPCUxFUm',
    description: 'Sessions filter — patient profile filter row and panel title',
  },
  searchForPatient: {
    defaultMessage: 'Search for a patient',
    id: 'BJmKGVkZpG',
    description: 'Placeholder for patient search in sessions filter and link popover',
  },
  noPatientFound: {
    defaultMessage: 'No patient found.',
    id: 'hVW2Hng8fB',
    description: 'Empty state when patient search in sessions filter returns no matches',
  },
  noSessionsFound: {
    defaultMessage: 'No sessions found',
    id: 'BJR5LEudCb',
    description: 'Empty state when the consolidated sessions list has no sessions',
  },
  untitledSession: {
    defaultMessage: 'Untitled session',
    id: 'KSJpKlvcDK',
    description: 'Fallback name for a session with no display name',
  },
  linkSessionToPatient: {
    defaultMessage: 'Link to patient',
    id: 'rC2DhS+s+H',
    description: 'Tooltip for linking a session to a patient from the list avatar',
  },
  resultCount: {
    defaultMessage: '{count, plural, one {# result} other {# results}}',
    id: 'MiZL/WlA4l',
    description: 'Session status filter row — count of sessions with that status',
  },
  uploadSchedule: {
    defaultMessage: 'Upload schedule',
    id: '9BJnfpL0UK',
    description: 'Button to open the upload session schedule modal',
  },
  searchSessionsTooltip: {
    defaultMessage: 'Search sessions',
    id: 'TqnnnLL3CP',
    description: 'Tooltip for the search sessions button in the sessions list header',
  },
  collapseSessionsTooltip: {
    defaultMessage: 'Collapse sessions',
    id: 'ET/hmaBypk',
    description: 'Tooltip for collapsing the sessions sidebar panel',
  },
  searchSessions: {
    defaultMessage: 'Search sessions',
    id: 'aWZzyB3FYG',
  },
  nSelected: {
    defaultMessage: '{count, plural, one {# selected} other {# selected}}',
    id: 'tKg7pfrrFv',
    description: 'Button showing how many sessions are selected for bulk actions',
  },
  actions: {
    defaultMessage: 'Actions',
    id: 'pUP67yNRjf',
    description: 'Bulk actions menu label for selected sessions',
  },
  delete: {
    defaultMessage: 'Delete',
    id: 'ORdpDnXo2I',
    description: 'Bulk delete action for selected sessions',
  },
});
